import React from 'react';
import { LogOut, Salad } from 'lucide-react';
import { NAV_ITEMS } from '../config/navItems';
import { openNutritionApp } from '../utils/crossAppSwitch';
import { useUnreadMessageCount } from '../hooks/useUnreadMessageCount';
import { colors as theme } from '../theme';

// Desktop counterpart to BottomNav.jsx — same NAV_ITEMS, same icon-led Cipher
// treatment, rendered by App.jsx at every view BottomNav covers rather than
// only on the dashboard, so a desktop client always has a way back to Workout
// instead of relying on a per-screen back arrow. Previously lived inline in
// ClientProgramView.jsx (so it only appeared on the dashboard) and included a
// "History" button that navigated to a view App.jsx never handled.
const DesktopTopNav = ({ currentView, userName, onNavigate, onLogout }) => {
  const unreadMessages = useUnreadMessageCount(currentView);

  return (
    <>
      <style>{`
        .desktop-top-nav { display: none; }
        @media (min-width: 769px) {
          .desktop-top-nav {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 20px;
            background: #141B3D;
            border-bottom: 1px solid rgba(42, 53, 98, 0.8);
            flex-wrap: wrap;
            gap: 8px;
            font-family: 'Inter', sans-serif;
          }
        }
        .desktop-nav-tab {
          display: flex;
          align-items: center;
          gap: 6px;
          padding: 8px 14px;
          background: transparent;
          border: 1px solid transparent;
          border-radius: 8px;
          font-size: 13px;
          font-weight: 600;
          cursor: pointer;
          white-space: nowrap;
          position: relative;
          transition: background 0.15s ease;
        }
        .desktop-nav-tab:hover { background: rgba(255,255,255,0.04); }
      `}</style>

      <nav className="desktop-top-nav">
        <span style={{ fontSize: '13px', fontWeight: 500, color: theme.textMuted }}>
          {userName ? `Welcome back, ${userName}` : ''}
        </span>
        <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
          {NAV_ITEMS.map(({ view, label, Icon }) => {
            const isActive = currentView === view;
            return (
              <button
                key={view}
                className="desktop-nav-tab"
                onClick={() => onNavigate?.(view)}
                style={{
                  color: isActive ? theme.gold : theme.text,
                  borderColor: isActive ? 'rgba(212,175,55,0.4)' : 'rgba(42,53,98,0.8)',
                }}
              >
                <Icon size={15} strokeWidth={1.8} />
                {label}
                {view === 'messages' && unreadMessages > 0 && (
                  <span style={{
                    position: 'absolute', top: '-6px', right: '-6px',
                    backgroundColor: theme.danger, color: theme.text,
                    borderRadius: '50%', minWidth: '16px', height: '16px',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: '11px', fontWeight: 700, padding: '0 3px',
                  }}>
                    {unreadMessages > 9 ? '9+' : unreadMessages}
                  </span>
                )}
              </button>
            );
          })}
          <button
            className="desktop-nav-tab"
            onClick={openNutritionApp}
            style={{ color: '#4A8F62', borderColor: 'rgba(74,143,98,0.4)' }}
          >
            <Salad size={15} strokeWidth={1.8} />
            Nutrition
          </button>
          <button
            className="desktop-nav-tab"
            onClick={onLogout}
            style={{ color: theme.danger, borderColor: 'rgba(255,59,48,0.3)' }}
          >
            <LogOut size={15} strokeWidth={1.8} />
            Logout
          </button>
        </div>
      </nav>
    </>
  );
};

export default DesktopTopNav;
